module.exports = __webpack_public_path__ + "img/bg3.fdfdf974.png";